import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { Outlet } from "react-router-dom";
import Banner from "../components/Banner/Banner";


function Layout(props) {

    return (
        <div style={{display:"flex", flexDirection:"column", alignItems:"space-between",  minHeight: "100vh"}}>
            <div style={{ flex: "1" }}>
                <Header />
                <main>
                    <Banner />
                    <Outlet />
                </main>
            </div>
            <Footer/>
        </div>

  );
}

export default Layout;
